<template>
  <a-modal title="清空课时内容" v-model="state.visible" @ok="confirm" @cancel="closeModal" :centered="true" width="80%">
    <div>
      <a-form-model layout="inline" :model="searchForm">
        <a-form-model-item label="课程名称">
          <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.courseName" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="课时排序">
          <a-input-group size="large">
            <a-row>
              <a-col :span="11">
                <a-input-number v-model="searchForm.minChildCourseDisplayOrder" :min="0" :max="9999" placeholder="最小值" />
              </a-col>
              <a-col :span="2" style="text-align: center; line-height: 32px; padding-left: 3px">~</a-col>
              <a-col :span="11">
                <a-input-number v-model="searchForm.maxChildCourseDisplayOrder" :min="searchForm.minChildCourseDisplayOrder" :max="9999" placeholder="最大值" />
              </a-col>
            </a-row>
          </a-input-group>
        </a-form-model-item>
        <a-form-model-item label="课时名称">
          <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.childCourseName" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="课时类型">
          <a-select class="serach-item" allowClear v-model="searchForm.childCourseType" placeholder="请选择">
            <a-select-option value="1">测评课时</a-select-option>
            <a-select-option value="2">训练课时</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="内容组成方式">
          <a-select class="serach-item" allowClear v-model="searchForm.composeMode" placeholder="请选择">
            <a-select-option value="0">固定内容</a-select-option>
            <a-select-option value="2">智能内容</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="学段">
          <a-select allowClear v-model="searchForm.periodList" placeholder="请选择" mode="multiple" style="min-width: 180px">
            <a-select-option :value="item" :key="item" v-for="item in $data._period">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="getPageList(1)" type="primary" html-type="button"> 查询 </a-button>
        </a-form-model-item>
      </a-form-model>
      <a-table
        style="min-width: 800px"
        :columns="columns"
        :scroll="{ y: 300 }"
        :rowKey="(text) => text.childCourseId"
        :pagination="tableRelevant.tablePagination"
        :loading="tableRelevant.tableLoading"
        :locale="tableRelevant.locale"
        :dataSource="tableRelevant.tableDataSource"
        :row-selection="rowSelection"
      >
        <div slot="courseName" slot-scope="text">
          <span>{{ text.courseName }}{{ text.period ? ' - ' + text.period : '' }}</span>
        </div>
        <div slot="courseType" slot-scope="text">
          <span>{{ $data._courseType[text.courseType] }}</span>
        </div>
      </a-table>
    </div>
  </a-modal>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'

export default {
  name: 'clearCourseContentRef',
  data() {
    return {
      searchForm: {
        courseType: undefined,
        courseName: undefined,
        childCourseName: undefined,
        childCourseType: undefined,
        minChildCourseDisplayOrder: undefined,
        periodList: [],
      },
      state: {
        visible: false,
        title: '清空课程',
      },
      tableRelevant: tableRelevant.call(this),
      tableSelectedRowKeys: [],
      options: {},
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.tableSelectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.tableSelectedRowKeys = selectedRowKeys
        },
      }
    },
    columns() {
      return [
        {
          title: '关联课程',
          scopedSlots: { customRender: 'courseName' },
        },
        {
          title: '课时排序',
          dataIndex: 'childCourseDisplayOrder',
        },

        {
          title: '关联课时',
          dataIndex: 'childCourseName',
        },
        {
          title: '课时类型',
          dataIndex: 'childCourseTypeName',
        },
      ]
    },
  },
  methods: {
    showModal(options) {
      return new Promise((resolve, reject) => {
        this._resolve = resolve
        this._reject = reject
        this.state.visible = true
        this.state.title = options.type == 2 ? '清空课程课时' : '清空课程'
        this.options = options
        this.getPageList()
      })
    },
    getPageList(pageIndex) {
      let params = {
        courseSeriesId: this.options.seriesId,
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      }
      params.minChildCourseDisplayOrder = this.searchForm.minChildCourseDisplayOrder || undefined
      params.maxChildCourseDisplayOrder = this.searchForm.maxChildCourseDisplayOrder || undefined
      this.tableRelevant.tableLoading = true
      this.$http.CourseResource.courseSessionSerie(params).then(({ data }) => {
        this.tableRelevant.tableDataSource = data.items
        this.tableRelevant.tablePagination.total = data.totalCount
        this.tableRelevant.tablePagination.current = data.pageIndex
        this.tableRelevant.tablePagination.pageSize = data.pageSize
      }).finally(() => {
        this.tableRelevant.tableLoading = false
      })
    },
    closeModal(reject) {
      this.state.visible = false
      this.tableSelectedRowKeys = []
      this.searchForm = {
        courseType: undefined,
        courseName: undefined,
        childCourseName: undefined,
        childCourseType: undefined,
        minChildCourseDisplayOrder: undefined,
        periodList: [],
      }
      reject ? this._reject() : this._resolve()
    },
    async confirm() {
      if (!this.tableSelectedRowKeys.length) {
        return this.$message.error('请勾选内容')
      }
      this.$confirm({
        title: '确定清空所选课程课时的所有内容？',
        content: '清空后所正在使用的课程课时将受到影响，请谨慎操作',
        onOk: async () => {
          const Parmas = {
            "courseSessionIds": this.tableSelectedRowKeys,
          }
          await this.$http.CourseResource.contentDelete(Parmas)
          this.$message.success('操作成功')
          this.closeModal()
        },
      })
    },
  },
}
</script>
